import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { OneOnOnesScheduledMeetingItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { DeleteMeetingDialog } from 'modules/meetings/components/DeleteMeetingDialog'
import { useMeetingNavigationItems } from 'modules/meetings/lib/hooks/useMeetingNavigationItems'

interface MeetingsNavigationProps {
  scheduledMeetings: OneOnOnesScheduledMeetingItemFragment[]
  employeeId: number
  refetch: () => void
}

export const MeetingsNavigation = ({
  scheduledMeetings,
  employeeId,
  refetch,
}: MeetingsNavigationProps) => {
  const { createMeetingItemsByMonth, meetingId, openDelete, meetingToDelete, handleCloseDelete } =
    useMeetingNavigationItems({
      employeeId,
      refetch,
    })

  const items = createMeetingItemsByMonth(scheduledMeetings)

  return (
    <>
      <F0TableOfContent
        key={JSON.stringify(scheduledMeetings.map((m) => m.id))}
        activeItem={meetingId}
        items={items}
        title={
          scheduledMeetings.length > 0
            ? i18n.t('meetings.one_on_ones.meeting_navigation.title')
            : i18n.t('meetings.one_on_ones.meeting_navigation.no_meetings')
        }
        collapsible
      />

      {meetingToDelete?.template?.id && (
        <DeleteMeetingDialog
          open={openDelete}
          onClose={handleCloseDelete}
          templateId={Number(meetingToDelete.template.id)}
          date={meetingToDelete?.date}
          frequency={meetingToDelete?.template?.frequency}
          meetingId={meetingToDelete?.id}
        />
      )}
    </>
  )
}
